var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { ref: "isoregionTooltip", staticClass: "margin-bottom-10" },
      [_vm._t("isoregion")],
      2
    ),
    _vm._v(" "),
    _c("div", { ref: "isocountryTooltip" }, [
      _c(
        "div",
        { staticClass: "margin-bottom-10" },
        [
          _c("h3", { staticClass: "entity__headline" }, [
            _c(
              "label",
              { staticClass: "required", attrs: { for: "isocountries" } },
              [_vm._v(_vm._s(_vm.trans("COMPANY_INSIGHTS_HEADQUARTER")))]
            ),
          ]),
          _vm._v(" "),
          _c("select-searchable", {
            attrs: {
              id: "isocountries",
              options: _vm.countries,
              disabled: _vm.allFiltersDisabled,
              "option-id-prefix": "isocountry_",
              name: "isocountries[]",
              "search-placeholder": _vm.trans("FORM_COUNTRY_SEARCH"),
              "search-name": _vm.ISO_SEARCH_FIELD_ID,
              "search-id": _vm.ISO_SEARCH_FIELD_ID,
            },
            on: { select: _vm.setSelectedCountry },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }